import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
// External dependencies
import { memo, } from 'react';
import { Box, Paper, Grid, Avatar, } from '@mui/material';
import { useTranslation } from 'react-i18next';
import MarkDown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';
import 'katex/dist/katex.min.css';
// Internal dependencies
import { appStyles } from '../App.styles';
import { waitingChatIconGif, } from '../assets/images';
import { chatStyles } from './Chat.styles';
import { preprocessLaTeX } from './preprocessLaTeX';
import { messagesBoxStyles } from './messagesBox.styles';
/**
 * Chat Ongoing Message component
 * @param props Chat Ongoing Message props
 * @returns Chat Ongoing Message element
 */
export const ChatOngoingMessage = memo(function ({ resContent }) {
    // Get translation function
    const { t, i18n } = useTranslation();
    return (_jsx(Paper
    // Waiting message
    , Object.assign({ 
        // Waiting message
        sx: chatStyles.aiMessageContainer }, { children: _jsxs(Grid, Object.assign({ container: true, columnSpacing: 2 }, { children: [_jsx(Grid, Object.assign({ item: true, sx: { display: 'flex', alignItems: 'flex-start', flexShrink: '0', } }, { children: _jsx(Avatar, Object.assign({ sx: { width: '2rem', height: '2rem', background: '#4B635A' } }, { children: 'AI' })) })), _jsxs(Grid, Object.assign({ item: true, xs: true, sx: {
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        flexShrink: '2',
                        boxSizing: 'border-box',
                        width: '100%',
                        overflow: 'auto',
                    } }, { children: [_jsx(Box, { component: "img", src: waitingChatIconGif, sx: {
                                width: '2.25rem',
                                height: '2.25rem',
                                display: resContent.length > 0 ? 'none' : 'flex',
                                boxSizing: 'border-box',
                            }, alt: "Waiting Icon" }), _jsx(Box, Object.assign({ component: MarkDown, remarkPlugins: [remarkMath, remarkGfm], rehypePlugins: [rehypeKatex], 
                            // Message text
                            sx: Object.assign(Object.assign({ display: resContent.length > 0 ? 'block' : 'none' }, appStyles.text16), messagesBoxStyles.message) }, { children: preprocessLaTeX(resContent) }))] }))] })) })));
});
